const channelKeys=["channel","cCode","cid","dc","_c","c","utm_source"] as const;
const channelStorageKey="fivek_acquisition_channel";
const legacyStorageKey="5knews_attribution_channel_v1";
const validChannel=/^[a-z0-9_-]{1,50}$/i;

export function acquisitionChannel(fallback="NATURAL"){
  const query=new URLSearchParams(location.search);
  const incoming=channelKeys.map(key=>query.get(key)?.trim()||"").find(value=>validChannel.test(value));
  if(incoming){
    localStorage.setItem(channelStorageKey,incoming);
    localStorage.setItem(legacyStorageKey,incoming);
    return incoming;
  }
  const saved=localStorage.getItem(channelStorageKey)||localStorage.getItem(legacyStorageKey)||"";
  return validChannel.test(saved)?saved:fallback;
}

